import { render, staticRenderFns } from "./ProductPageScreenRingHolder.vue?vue&type=template&id=dcaafb86&scoped=true&"
import script from "./ProductPageScreenRingHolder.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenRingHolder.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenRingHolder.vue?vue&type=style&index=0&id=dcaafb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaafb86",
  null
  
)

export default component.exports